<!--
アンケート
URL：question/edit
-->

<template>
  <div>
    <v-container style="max-width: 800px">
      <p class="text-center text-h3">アンケート</p>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4" :class="{ 'card-error': !formData.title }">
        <v-card-title class="custom-card-title">
          タイトル
          <v-icon class="ml-1 mb-3 red--text caption">mdi-asterisk</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  color="#0ddbc7"
                  regular
                  hide-details="auto"
                  dense
                  class="text-h6 text-align:center"
                  v-model="formData.title"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">説明</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                  color="#0ddbc7"
                  outlined
                  hide-details="auto"
                  v-model="formData.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">開始日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                  :dateSub="formData.started_at"
                  :defaultFocus="formData.started_at"
                  @on-update-registration-date="formData.started_at = $event"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="custom-card-title">終了日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                  :dateSub="formData.ended_at"
                  :defaultFocus="formData.ended_at"
                  @on-update-registration-date="formData.ended_at = $event"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
          v-for="(item, index) in formData.items"
          :key="index"
          elevation="5"
          class="ma-4"
          :class="{ 'card-error': !isValidItem(item) }"
      >
        <v-card-title class="custom-card-title jutsity-between">
          設問{{ index + 1 }}
          <v-btn
              slot="append"
              icon
              outlined
              color="primary"
              class="ml-2"
              :disabled="index === 0"
              @click="changeOrder(index, index - 1)"
            >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
          <v-btn
              slot="append"
              icon
              outlined
              color="primary"
              class="ml-2"
              :disabled="index === formData.items.length - 1"
              @click="changeOrder(index, index + 1)"
          >
            <v-icon>mdi-arrow-down</v-icon>
          </v-btn>
          <v-btn
              slot="append"
              icon
              outlined
              color="primary"
              class="ml-auto"
              @click="removeItem(index)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="custom-card-subtitle mt-0">説明</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                  color="#0ddbc7"
                  outlined
                  hide-details="auto"
                  v-model="item.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="回答必須"
                  color="#0ddbc7"
                  hide-details="auto"
                  v-model="item.required"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle class="custom-card-subtitle">種別</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  v-model="item.type"
                  :items="typeItems"
                  color="#0ddbc7"
                  dense
                  hide-details
                  outlined
                  @change="changeType(item)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <template v-if="typeHasOption(item.type)">
          <v-card-subtitle class="custom-card-subtitle">選択肢</v-card-subtitle>
          <v-card-text>
            <v-row v-for="(option, index) in item.options" :key="index">
              <v-col cols="11">
                <v-text-field
                    color="#0ddbc7"
                    regular
                    hide-details="auto"
                    dense
                    class="text-h6 text-align:center"
                    v-model="option.value"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-btn slot="append" icon outlined color="primary" @click="item.options.splice(index, 1)">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="item.options.push({value: null})">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card>

      <v-row align="center">
        <v-col align="center">
          <v-btn slot="append" icon outlined color="primary" @click="addItem">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
              color="secondary"
              outlined
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="cancel"
          >やめる
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              color="primary"
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="inputCheck"
          >保存
          </v-btn>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import CustomDatePicker from "../../components/question-edits/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    alert: Alert,
  },
  data() {
    return {
      id: '',
      isCreate: true,
      errors: [],

      formData: {
        title: null,
        description: null,
        started_at: null,
        ended_at: null,
        items: [],
      },
    };
  },
  mounted() {
    this.isCreate = this.$route.params.uid == 'create';

    if (!this.isCreate) {
      this.id = Number(this.$route.params.uid);
      this.$store.commit("setWaiting", true);
      // アンケートを取得する
      Api.call("/question", {"id": this.id})
        .then((result) => {
          this.$store.commit("setWaiting", false);
          this.formData.title = result.title;
          this.formData.description = result.description;
          this.formData.started_at = result.started_at;
          this.formData.ended_at = result.ended_at;
          this.formData.items = result.items
            .map(el => ({...el, options: this.typeHasOption(el.type) ? el.options : null}));
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    }
  },
  computed: {
    typeItems() {
      return [
        {value: 'text', text: 'テキスト'},
        {value: 'radio', text: 'ラジオボタン'},
        {value: 'checkbox', text: 'チェックボックス'},
      ];
    },
  },
  methods: {
    addItem() {
      this.formData.items.push({
        type: 'text',
        description: null,
        required: false,
        options: null,
      });
    },
    changeType(item) {
      if (this.typeHasOption(item.type)) {
        if (item.options == null) {
          item.options = [];
        }
      } else {
        item.options = null;
      }
    },
    typeHasOption(type) {
      return type === 'radio' || type === 'checkbox';
    },
    isValidItem(item) {
      if (!this.typeHasOption(item.type)) {
        return true;
      } else if (!item.options || item.options.length === 0) {
        return false;
      }
      for (const option of item.options) {
        if (!option.value) {
          return false;
        }
      }
      return true;
    },
    removeItem(index) {
      this.formData.items.splice(index, 1);
    },
    changeOrder(index1, index2) {
      let items = [...this.formData.items];
      [items[index1], items[index2]] = [items[index2], items[index1]];
      this.formData.items = items;
    },

    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },

    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },

    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
      this.clearMessage();

      if (!this.formData.title) {
        this.showMessage(AlertBuilder.error("タイトルを入力してください"));
        return;
      }
      if (this.formData.items.length === 0) {
        this.showMessage(AlertBuilder.error("設問を追加してください"));
        return;
      }
      for (const item of this.formData.items) {
        if (!this.isValidItem(item)) {
          this.showMessage(AlertBuilder.error("選択肢を設定してください"));
          return;
        }
      }

      this.register();
    },

    register() {
      let updateUrl = "/question/update";
      let postData = {...this.formData};
      if (!this.isCreate) {
        postData['id'] = this.id;
      }

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then(() => {
            this.$store.commit("setWaiting", false);
            this.$router.push("/question");
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },
    cancel() {
      this.$router.push("/question");
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}

.card-error {
  background-color: #ffdbe2;
}

.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}

.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}

.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}

.big-checkbox {
  transform: scale(1.4);
  transform-origin: 0% 50%;
  font-size: 24px;
  /* margin-left: 24px; */
  margin-right: 24px;
}

.v-text-field >>> input {
  font-size: 24px;
  padding: 0 !important;
}

.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
